:host {
  display: block;
}

av-select{
  padding: 10px 20px 10px 5px;
}